import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({}, { clipRadius })=>({
        infiniteScroll: {
            overflow: 'hidden !important'
        },
        clip: {
            clipPath: clipRadius ? `inset(0 round ${clipRadius}px)` : void 0
        },
        overflowVisible: {
            overflow: 'visible !important'
        }
    }));
export { useStyles };
